import { GTMProduct, GTMPurchaseEventProps, GTMUserData } from '../model';

export type PurchaseEvent = {
    event: 'eec_purchase';
    ecommerce: {
        currencyCode?: string;
        purchase: {
            actionField: {
                id: string;
                revenue?: string;
                tax?: string;
                shipping?: string;
                coupon?: string[];
                affiliation?: string;
            };
            products: GTMProduct[];
        };
    };
    user_data?: GTMUserData;
    payment_type: string;
    shipping_tier: string;
};

export const trackPurchaseEvent = (props: GTMPurchaseEventProps): PurchaseEvent => ({
    event: 'eec_purchase',
    ecommerce: {
        currencyCode: props.currencyCode,
        purchase: {
            actionField: {
                id: props.orderId || '',
                revenue: props.totalPrice,
                tax: props.vatPrice,
                shipping: props.shippingPrice,
                coupon: props.coupon,
                affiliation: 'Webshop',
            },
            products: props.products || [],
        },
    },
    user_data: props?.userData,
    payment_type: props.paymentType || '',
    shipping_tier: props.shippingTier || '',
});
